import React from 'react';
import TranslatedComponent from '../../utils/TranslatedComponent';

export class NonSVGLogo extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var id = this.props.logo + '-logo';
    var path = '/resources/assets/img/' + this.props.logo + '.' + this.props.filetype;

    return (
      <span>
        <img id={id} src={path} alt={id}/>
      </span>
    );
  }
}

TranslatedComponent(NonSVGLogo);
export default NonSVGLogo;



// WEBPACK FOOTER //
// ./client/src/components/logos/NonSVGLogo.jsx